<template>
    <div class="about_menu_top  textalign_left">
        <div style="background: #fff;max-width: 1920px;margin: 0 auto;"  class="ms-controller">
        <div style="margin: 0 auto;font-size: 0">
            <div style="height: 7367px;background: url('http://p1.fishqc.net/FjDolHAtIt5NNtrWmBn0qsn4p6e8') center center no-repeat;background-size: auto 100%;padding-top: 550px;box-sizing: border-box;">
                <div style="width:1056px;margin:0 auto;display:block;position: relative;font-size:36px;font-family:PingFang SC;color:533727;height: 100%;text-align: center;">
                    <div class="top_desc">准妈妈们从怀孕就开始关注各种母婴用品，但面对琳琅满目的产品，也不免陷入纠结：到底该买哪一个？哪件才是真正有用值得买的？哪些产品才足够安全放心？</div>
                    <div class="top_desc">妈妈网联合小鱼亲测打造了“绿鱼妈妈亲测榜”，对市面上的宝宝及妈妈用品进行科学测评，为母婴人群推荐真正实用的母婴必备好物。</div>

                    <div class="padding_top_162">
                        <div class="productbox" v-for="(item,index) in zhuanti_product">
                            <div class="textalign_center">
                                <div class="productbox_title">{{item.title}}</div>
                            </div>
                            <div v-for="(val,index1) in item.product">
                                <div v-if="val.type == 'left'" >
                                    <div :class="['display_flex','zhuan_padding_30','align-items_center','text_left',(val.id == 'EhGmxkSgwhplmjwE8KmTKQ'?'productheigth1':''),(val.id == '6_Cp682RO08-G9JngiFewA'?'productheigth2':''),(val.id == 'AQOm0_dBTftybNGUusasrw'?'productheigth3':''),(val.id == 'P-y1BJ9q-FQH48JnSXTubQ'?'productheigth4':'') ]">
                                        <div class="zhuan_relative" @click="toproductdetail(val.productype,val.id)" style="cursor: pointer;">
                                            <img :src="val.img" :class="[val.imgclass]"></img>
                                            <img v-if="(val.id == 'AQOm0_dBTftybNGUusasrw') || (val.id == 'P-y1BJ9q-FQH48JnSXTubQ')" src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" :class="['greenfish_icon',val.greenicon]"></img>
                                            
                                        </div>
                                        <div :class="['flex_1','padding_left_590',(val.id == 'AQOm0_dBTftybNGUusasrw'?'height1 display_flex flex-direction_column justify-content_flex-justify':'')]" @click="toproductdetail(val.productype,val.id)" style="cursor: pointer;">
                                            <div>
                                                <div class="productname">{{val.productName}}</div>
                                                <div class="productname">{{val.productName1}}</div>
                                            </div>
                                            <div>
                                                <div class="product_effency" v-if="val.effecy !== ''">{{val.effecy}}</div>
                                                <div>
                                                   <div :class="[val.tipslabelclass]">{{val.tips}}</div> 
                                                </div>
                                                
                                                <div class="address">品牌所在地：{{val.address}}</div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div v-if="val.type == 'right'">
                                    <div :class="['display_flex','zhuan_padding_30','align-items_center','text_right',(val.id == 'EhGmxkSgwhplmjwE8KmTKQ'?'productheigth1':''),(val.id == '6_Cp682RO08-G9JngiFewA'?'productheigth2':''),(val.id == 'AQOm0_dBTftybNGUusasrw'?'productheigth3':''),(val.id == 'P-y1BJ9q-FQH48JnSXTubQ'?'productheigth4':'') ]">
                                        <div :class="['flex_1',( val.id == 'P-y1BJ9q-FQH48JnSXTubQ'?'height1 display_flex flex-direction_column justify-content_flex-justify':'')]" @click="toproductdetail(val.productype,val.id)" style="cursor: pointer;">
                                            <div>
                                                <div class="productname">{{val.productName}}</div>
                                                <div class="productname">{{val.productName1}}</div>
                                            </div>
                                            <div>
                                                <div class="product_effency" v-if="val.effecy !== ''">{{val.effecy}}</div>
                                                <div>
                                                   <div :class="[val.tipslabelclass]">{{val.tips}}</div> 
                                                </div>
                                                <div class="address">品牌所在地：{{val.address}}</div>
                                            </div>
                                        </div>
                                        <div style="cursor: pointer;" class="zhuan_relative" @click="toproductdetail(val.productype,val.id)">
                                            <img ms-attr="{src:val.img}" :class="[val.imgclass]"></img>
                                            <img v-if="(val.id == 'AQOm0_dBTftybNGUusasrw') || (val.id == 'P-y1BJ9q-FQH48JnSXTubQ')" src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" :class="['greenfish_icon',val.greenicon]"></img>
                                            
                                        </div>
                                        
                                    </div>
                                </div>

                                <div class="text_left">
                                    <div class="padding_bottom_30">
                                        <span class="subtitle_box">{{val.momspeaker}}</span>
                                        <div class="subbox_desc">
                                            <div class="subbox_desc1">{{val.mondesc}}</div>
                                        </div>
                                    </div>
                                    <div class="padding_bottom_30">
                                        <span class="subtitle_box">{{val.effecytitler}}</span>
                                        <div class="subbox_desc">
                                            <div class="subbox_desc1">{{val.effecymethor}}</div>
                                            <div>
                                                <img :src="val.effencyImg"  :class="[val.effencyImgclass]"></img>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="padding_bottom_34">
                                        <span class="subtitle_box">{{val.liyou}}</span>
                                        <div class="subbox_desc">
                                            <div class="subbox_desc1">{{val.liyoudesc}}</div>
                                            <div class="subbox_desc1" v-if="val.liyoudesc1">{{val.liyoudesc1}}</div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div>
                       <img src="http://p1.fishqc.net/Fv5P1kY5HQPMwkxdsO7bwiG5kX7o" class="bottom_img1"></img>
                    </div>
                     <div>
                       <video src="https://p1.fishqc.net/ii3IfaO87cMoOdT0C84j88pe.mp4" controls class="videoclass"  poster="http://p1.fishqc.net/FqFcjYBzzWX-5h83tBby6R-qaskN" ></video>
                    </div>
                     <div>
                       <img src="http://p1.fishqc.net/Fj2gezL8cgzQvBUKhMpyWsnutXBO" class="bottom_img2"></img>
                    </div>
                    <div class="bottom_box">
                        <div class="bottom_box_content">“绿鱼妈妈亲测榜”是妈妈网与小鱼亲测联合打造的重磅IP，旨在为妈妈们甄选值得信赖的口碑好物。</div>
                        <div class=" bottom_box_content padding_top_20">上榜产品均通过了小鱼亲测应用“诺贝尔奖”的权威检测科技，以及妈妈网资深编辑专业评测，让妈妈们买得放心、宝宝们用得放心。</div>
                    </div>
                    <div>
                       <img src="http://p1.fishqc.net/FgIGv4g3s0XGXL304_yAVVUyZw6L" class="bottom_img3"></img>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/*.display_flex > *{
     display: block;
 }*/
.display_inline-flex {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-inline-flex;
    display: inline-flex;
}


/*伸縮流方向*/
.flex-direction_column {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
}

/*主軸對齊*/
.justify-content_flex-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.justify-content_flex-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.justify-content_flex-justify {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

/*側軸對齊*/
.align-items_flex-start {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.align-items_flex-end {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}

.align-items_center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.align-items_baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    align-items: baseline;
}

.align-items_space_between {
    -webkit-box-align: space-between;
    -ms-flex-align: space-between;
    -webkit-align-items: space-between;
    align-items: space-between;
}

.horizontal-between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
}

/*伸縮性*/
.flex_auto {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    -webkit-flex: auto;
    flex: auto;
}

.flex_1 {
    width: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.flex_2 {
    width: 0;
    -webkit-box-flex: 2;
    -ms-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}


.flex-wrap_wrap {
    flex-wrap: wrap;
}


.top_desc{
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 44px;
    text-align: left;
}
.top_desc:nth-of-type(1){
    padding-top: 10px;
    box-sizing: border-box;
}
.productbox_title{
    width: 510px;
    height: 70px;
    background: #FFCA27;
    border-radius: 0px 0px 50px 50px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #FFFFFF;
    text-align: center;
    line-height: 70px;
    display: inline-block;
}
.productbox{
    width: 1056px;
    border-radius: 24px;
    padding:0 62px 66px;
    margin:0 auto;
    background:#FFFDF2;
    box-sizing: border-box;
}
.productbox:nth-of-type(1){
    margin-top:152px;
}
.productbox:nth-of-type(2){
    margin-top:72px;
}

.productheigth1{
    height:352px;
}
.productheigth2{
    height:370px;
}
.productheigth3{
    height:350px;
}
.productheigth4{
    height:430px;
}

.zhuan_relative{
    position:relative;
    height: 100%;
}

.productname{
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #1F5C77;
    line-height: 28px;
    
}
.productname:nth-of-type(2n){
        padding-top:15px;
        box-sizing:border-box;
    }
.address{
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1F5C77;
    padding-top:16px;
    box-sizing:border-box;
}
.product_effency{
    padding:12px 50px 12px 14px;
    box-sizing:border-box;
    font-size: 24px;
    line-height:24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    background: #429AA5;
    border-radius: 0px 50px 50px 0px;
    display:inline-block;
    margin:16px 0 0px;
    position: relative;

}
.product_effency:after{
    width: 50px;
    height: 50px;
    content: '';
    position: absolute;
    top: 0;
    right: 0px;
    background-image: url(https://so.fishqc.com/img/search/effect.png);
    background-position: center right;
    background-repeat: no-repeat;
    background-size: 46px 46px;
}

.text_left{
    text-align: left;
}
.text_right{
    text-align: right;
}

.tipslabel{
    width: 134px;
    height: 40px;
    background: #D2F2EE;
    border-radius: 16px 0px 16px 0px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #44CCBD;
    line-height:40px;
    text-align:center;
    margin-top:16px;
    display: inline-block;
}

.produtImg{
    width:331px;
    height:370px;
    position:absolute;
    left:140px;
    top:78px;
}
.produtImg2{
    width:160px;
    height:405px;
    position:absolute;
    left:234px;
    top:80px;
}
.produtImg3{
    width:184px;
    height:398px;
    position:absolute;
    left:212px;
    top:72px;
}
.produtImg4{
    width:98px;
    height:524px;
    position:absolute;
    left:253px;
    top:93px;
}
.greenfish_icon{
    width:120px;
    height:120px;
}
.greenicon1{
    position:absolute;
    left:340px;
    bottom:64px;
}
.greenicon2{
    position:absolute;
    left:340px;
    bottom:64px;
}

.zhuan_padding_30{
    padding:0 30px;
    box-sizing:border-box;
}

.padding_bottom_30{
    padding-bottom:32px;
    box-sizing:border-box;
}

.subtitle_box{
    line-height:44px;
    background: #15BBA6;
    padding:0 32px 0 20px;
    box-sizing:border-box;
    display:inline-block;

    height: 44px;
    background: #15BBA6;
    border-radius: 0px 30px 0px 0px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;

}

.subbox_desc{
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1F5C77;
    line-height: 48px;
    padding:26px 32px 18px;
    box-sizing:border-box;
    background-color:#fff;
    border-radius: 0px 16px 16px 16px;
    box-shadow: 0px 0px 20px rgba(255,202,39,.1);
    text-align: justify;
    
}
.subbox_desc1{
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1F5C77;
    line-height: 30px;
    text-align: left;
    
}
.subbox_desc .padding_top_10{
        padding-top:10px;
        box-sizing:border-box;
    }

.pic1{
    width:787px;
    height:211px;
    display:block;
    margin:24px 0 0;
}
.pic2{
    width:699px;
    height:394px;
    display:block;
    margin:24px 0 0;
}

.pic3{
    width:856px;
    height:154px;
    display:block;
    margin:32px auto 0;
}

.bottom_img1{
    width:670px;
    height:54px;
    display:block;
    margin:80px auto 0;
}
.bottom_img2{
    width:410px;
    height:54px;
    display:block;
    margin:80px auto 0; 
}
.videoclass{
    display:block;
    box-sizing:border-box;
    overflow: hidden;
    width:auto;
    height: 577px;
    border-radius: 24px;
    margin:44px auto 0;
   
    
}
.videlcontain{
    width:100%;
    height:100%;
}
.bottom_box{
    width: 1056px;
    background: #FFFFFF;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1F5C77;
    line-height: 30px;
    text-align: left;
    padding:42px 62px;
    margin:44px auto 0;
}
.bottom_box_content{
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1F5C77;
    line-height: 30px;
}
.bottom_img3{
    width:334px;
    height:46px;
    display:block;
    margin:160px auto 0;
}

.height1{
    height: 212px;
}

.padding_top_20{
    padding-top: 15px;
    box-sizing: border-box;
}

.videobg{
    width: 100%;
    height: 577px;
    padding:8px;
    box-sizing: border-box;
    margin-top: 44px;
     border: 8px solid;
     border-color:yellow;
}

.padding_left_590{
    padding-left: 530px;
    box-sizing: border-box;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            zhuanti_product:[
                {
                    title:'妈妈好物，由内而外锁住好气色',
                    product:[
                        {
                            type:'left',
                            productName:'红色小象',
                            productName1:'日本晚樱套装',
                            effecy:'保湿功效显著',
                            address:'中国',
                            id:'EhGmxkSgwhplmjwE8KmTKQ',
                            productype:'cosmetic',
                            img:'http://p1.fishqc.net/FoHOT4RWD6rzMpPLycql4pawYJ3-',
                            imgclass:'produtImg',
                            momspeaker:'绿鱼妈妈说',
                            mondesc:'孕期体内激素分泌增加，且新陈代谢较快，容易导致皮肤缺水严重，甚至干燥起皮，孕妈们更需要保湿功效显著的护肤品，给皮肤增加水分。',
                            effecytitler:"保湿功效测试",
                            effecymethor:"斑马鱼在水体盐度增加时也会像人体皮肤一样会失水萎缩，斑马鱼胚胎经较高盐度处理变成失水模型，比对样品的保湿效果。",
                            effencyImg:'http://p1.fishqc.net/FtS0qTvpN4BZ5_rqCosCKwk1-5bs',
                            effencyImgclass:'pic1',
                            liyou:'上榜理由',
                            liyoudesc:'通过绿鱼妈妈亲测功效检测，红色小象日本晚樱套装保湿效果大于30%，保湿功效显著，能帮助孕妈们缓解皮肤缺水情况，是广受孕妈们喜爱的保湿护肤产品。',
                            liyoudesc1:'',
                            tips:'补水保湿',
                            tipslabelclass:'tipslabel'
                        },
                        {
                            type:'left',
                            productName:'JIAO QU胶趣',
                            productName1:'鲜炖红枣花胶',
                            effecy:'增加皮肤弹性功效显著',
                            address:'中国',
                            id:'6_Cp682RO08-G9JngiFewA',
                            productype:'food',
                            img:'http://p1.fishqc.net/FljyZCmAcqCuKcDW3JZwWk5VMSbr',
                            imgclass:'produtImg2',
                            momspeaker:'绿鱼妈妈说',
                            mondesc:'孕期补充胶原蛋白最好通过食物，除了有助于胎儿骨骼和皮肤组织的生长发育外，胶原蛋白还能缓解孕期肌肤的干燥和松弛，可以保持肌肤的水润和弹性。',
                            effecytitler:"增加皮肤弹性功效测试",
                            effecymethor:"斑马鱼皮肤里的胶原蛋白和人体皮肤的胶原蛋白具有约77%的氨基酸排列一致性，通过对胶原蛋白基因表达量进行测量，胶原蛋白基因表达量增加，即促进胶原蛋白再生效果显著。",
                            effencyImg:'http://p1.fishqc.net/FiA0fV5PLRAB_i2cKWSpSoB_W6Hq',
                            effencyImgclass:'pic2',
                            liyou:'上榜理由',
                            liyoudesc:'通过绿鱼妈妈亲测功效检测，胶趣鲜炖红枣花胶增加皮肤弹性功效大于90%，促进胶原蛋白再生效果显著，对胎儿生长发育及孕期皮肤保养有好处。 ',
                            liyoudesc1:'同时，胶趣鲜炖花胶中固体含量高达75%以上，0添加0防腐剂，是孕妈们安心滋补，保养修复的优选品。',
                            tips:'滋补养颜',
                            tipslabelclass:'tipslabel'
                        },
                        
                        
                    ]

                },
                {
                    title:'宝宝好物，吃穿必须安全第一位',
                    product:[
                        {
                            type:'left',
                            productName:'米小芽',
                            productName1:'香香的鲜脆虾片',
                            effecy:'',
                            address:'中国',
                            id:'AQOm0_dBTftybNGUusasrw',
                            productype:'food',
                            img:'http://p1.fishqc.net/Fu0l5tV-kmeAsYv-Wmp-JqftqoiG',
                            imgclass:'produtImg3',
                            momspeaker:'绿鱼妈妈说',
                            mondesc:'宝宝零食能够补充宝宝身体活动所需的能量。但如果添加不合适，会造成很大健康问题。正确使用宝宝零食能更有效地为宝宝补充能量，有益宝宝健康成长。选择品质卓越的绿鱼宝宝零食，宝宝开心妈妈放心。',
                            effecytitler:"绿鱼评级",
                            effecymethor:"获得绿鱼评级的产品在鲭鳉鱼胚胎慢性毒物测试中，符合参考世界卫生组织（WHO）安全指引;在斑马鱼胚胎急性毒物测试中，符合高浓度鱼胚胎测试标准；在成分筛查中，没有禁用成分或高度关注成份。代表品质卓越，消费者可以安心选购。",
                            effencyImg:'http://p1.fishqc.net/FhixXEgen_PR-QTsiPho1nxTKd2t',
                            effencyImgclass:'pic3',
                            liyou:'上榜理由',
                            liyoudesc:'通过绿鱼妈妈亲测最高安全评级，米小芽香香的鲜脆虾片为绿鱼产品，品质卓越，是妈妈们可以放心选择的宝宝零食。',
                            liyoudesc1:'另外，该产品非油炸非膨化，0防腐剂，蛋白质含量是纯牛奶的3倍，对宝宝免疫力更有益。',
                            tips:'健康美味',
                            tipslabelclass:'tipslabel',
                            greenicon:'greenicon1'
                        },
                        {
                            type:'left',
                            productName:'Hachu哈邱',
                            productName1:'婴儿酵素洗衣精华液',
                            effecy:'',
                            address:'中国',
                            id:'P-y1BJ9q-FQH48JnSXTubQ',
                            productype:'cosmetic',
                            img:'http://p1.fishqc.net/FluEa3z_aEokrC_ynZsrZg4hfINC',
                            imgclass:'produtImg4',
                            momspeaker:'绿鱼妈妈说',
                            mondesc:'婴儿皮肤抵抗力差，对洗衣液的残留更敏感，且容易受香味香料等刺激，抓咬衣服时更有可能吸入有害添加物，选购婴儿洗衣液时更需要注意产品的安全，避免安全问题发生。',
                            effecytitler:"绿鱼评级",
                            effecymethor:"获得绿鱼评级的产品在鲭鳉鱼胚胎慢性毒物测试中，符合参考世界卫生组织（WHO）安全指引;在斑马鱼胚胎急性毒物测试中，符合高浓度鱼胚胎测试标准；在成分筛查中，没有禁用成分或高度关注成份。代表品质卓越，消费者可以安心选购。",
                            effencyImg:'http://p1.fishqc.net/FhixXEgen_PR-QTsiPho1nxTKd2t',
                            effencyImgclass:'pic3',
                            liyou:'上榜理由',
                            liyoudesc:'通过绿鱼妈妈亲测最高安全评级，哈邱婴儿酵素洗衣精华液达到绿鱼品质卓越评级，可放心使用。',
                            liyoudesc1:'该产品为3倍高浓缩液，一瓶等于三瓶的量，快速瓦解顽固污迹，高效洁净。 ',
                            tips:'天然安全',
                            tipslabelclass:'tipslabel',
                            greenicon:'greenicon2'
                        },
                        
                        
                    ]

                }
            ],
            imgarr:['https://product.fishqc.com/img/activity/618/tech.png','https://product.fishqc.com/img/activity/618/tech-white.png','https://product.fishqc.com/img/activity/618/tech-kangyang.png'],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>